var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9382 6.03283L12.0443 5.92676L11.9382 5.8207L10.6793 4.56176L10.5732 4.4557L10.4672 4.56176L2.1746 12.8543L2.13067 12.8983V12.9604V14.2193V14.3693H2.28067H3.5396H3.60173L3.64567 14.3254L11.9382 6.03283ZM12.985 4.7739L13.0911 4.87996L13.1972 4.7739L14.4561 3.51496L14.5622 3.4089L14.4561 3.30283L13.1972 2.0439L13.0911 1.93783L12.985 2.0439L11.7261 3.30283L11.62 3.4089L11.7261 3.51496L12.985 4.7739ZM16.1332 3.93231L4.21555 15.85H0.65V12.2844L12.5677 0.36676C12.5677 0.366755 12.5677 0.366749 12.5677 0.366744C12.7065 0.227963 12.8948 0.15 13.0911 0.15C13.2874 0.15 13.4757 0.227969 13.6145 0.36676L16.1332 2.88548C16.272 3.02432 16.35 3.21259 16.35 3.4089C16.35 3.60521 16.272 3.79348 16.1332 3.93231Z",
    fill: "#2E2E2E",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDark);
export default __webpack_public_path__ + "static/media/edit-dark.e38abaf491bfc7e3767a5000063c64ec.svg";
export { ForwardRef as ReactComponent };